export default __webpack_public_path__ + "static/media/5 chamod.9e7277ac.png";